import React, {Component} from 'react';
import Select from "../../../local_node_modules/react-select"
import '../../../local_node_modules/react-select/dist/react-select.css';
import {UncontrolledTooltip} from 'reactstrap';
import {validateField} from "../../../common/validation";
import {decideBankType, deepCopyObject, ibanExistsInPaymentArray, showAxiosError} from "../../../helper/helper";
import Alert from "react-s-alert";
import {request} from "../../../helper/APIUtils";
import {CopyToClipboard} from "react-copy-to-clipboard";
import Datetime from "react-datetime";
import moment from "moment";
import {showChemistInformationModal} from "../../../helper/permission";
import {CustomerBankType} from "../../../helper/enums";


class Payment extends Component {
  constructor(props) {
    super(props);
    this.state = {error: {}, paymentInfo: null,notManualInput:false,ibanList:[]} ;
    this.onChange = this.onChange.bind(this);
    this.validateField = this.validateField.bind(this);
    this.clearPayment = this.clearPayment.bind(this);
    this.switchManualItemName=this.switchManualItemName.bind(this);
    this.getIbanList = this.getIbanList.bind(this);
    this.copyExternalCustomer = this.copyExternalCustomer.bind(this);
    this.decideIban = this.decideIban.bind(this);
    this.getIbanList();
  }

  componentDidMount() {
    this.getIbanList(() => {
      if (!this.state.notManualInput && this.state.ibanList.length > 0) {
        this.selectDefaultIban();
      }
    });

    this.setState({ paymentInfo: this.props.paymentInfo });
  }

  switchManualItemName(e) {
    let self=this;
    self.setState({notManualInput: !e.target.checked});
    let message = "";
    if (e.target.checked) {
      message = "IBAN manuel giriş <strong style='font-weight: 100'>aktif</strong> hale getirildi.";
    } else {
      message = "IBAN manuel giriş <strong style='font-weight: 100'>pasif</strong> hale getirildi.";
    }
    Alert.info(message, {
      position: 'top-right',
      effect: 'stackslide',
      timeout: 1000,
      html: true
    });
  }

  onChange(e) {
    this.validateField(e);
    let {name,value}=e.target;
    if (name === "paymentFinancialAccountId") {
      value = value.replace(/\s/g, '');
      value = value.toUpperCase();
    }
    let paymentInfo = deepCopyObject(this.state.paymentInfo);
    paymentInfo[name] = value;

    this.setState({paymentInfo});
    this.props.listener(paymentInfo);
  }


  onChangePaymentMeansCode = (selectedOption) => {
    let paymentInfo = deepCopyObject(this.state.paymentInfo);
    paymentInfo['paymentMeansCode'] = selectedOption.value;
    this.setState({paymentInfo}, () => this.props.listener(paymentInfo));
  }

  onChangePaymentChannelCode = (selectedOption) => {
    let paymentInfo = deepCopyObject(this.state.paymentInfo);
    paymentInfo['paymentChannelCode'] = selectedOption.value;
    this.setState({paymentInfo}, () => this.props.listener(paymentInfo));
  }

  onChangeIbanSelect = (selectedOption) => {
    if (selectedOption) {
      const { value } = selectedOption;
      let paymentInfo = deepCopyObject(this.state.paymentInfo);
      paymentInfo['paymentFinancialAccountId'] = value;
      this.setState({ paymentInfo }, () => this.props.listener(paymentInfo));
    }
  }

  toggleManualInput = () => {
    this.setState(prevState => {
      const isManualInput = !prevState.notManualInput;
      let paymentInfo = deepCopyObject(prevState.paymentInfo);
      if (!isManualInput && prevState.ibanList && prevState.ibanList.length > 0) {
        paymentInfo['paymentFinancialAccountId'] = prevState.ibanList[0].iban;
      } else if (isManualInput) {
        if (prevState.paymentInfo.paymentFinancialAccountId && ibanExistsInPaymentArray(prevState.ibanList, prevState.paymentInfo.paymentFinancialAccountId)) {
          paymentInfo['paymentFinancialAccountId'] = prevState.paymentInfo.paymentFinancialAccountId;
        } else {
          paymentInfo['paymentFinancialAccountId'] = '';
        }
      }
      return { notManualInput: isManualInput, paymentInfo };
    }, () => {
      this.props.listener(this.state.paymentInfo);
    });
  }

  validateField(e) {

    let id = e.target.id;
    let rule = e.target.dataset.vdata;
    let boundary = e.target.dataset.vlength;
    let result;

    if (this.props.isKamu()) {
      result = {valid: true, message: ''}
    } else {
      result = validateField(rule, boundary, e.target.value);
    }

    let error = this.state.error;
    error = Object.assign(error, {[id]: result});
    this.setState({error});
    this.props.errorListener(error);
  }

  clearPayment(){
    let {paymentInfo}= this.state;
    paymentInfo["paymentMeansCode"] = null;
    paymentInfo["paymentChannelCode"] = null;
    paymentInfo["paymentFinancialAccountId"] = null;
    paymentInfo["instructionNote"] = null;
    paymentInfo["paymentFormattedName"] = null;
    paymentInfo["paymentVkn"] = null;
    paymentInfo["paymentCity"] = null;
    paymentInfo["paymentCountry"] = null;
    paymentInfo["paymentDueDate"] = null;
    paymentInfo["payerFinancialAccountId"] = null;
    paymentInfo["payerFinancialInstitution"] = null;
    paymentInfo["payeeFinancialInstitution"] = null;
    paymentInfo["payeeFinancialAccountId"] = null;

    this.setState({paymentInfo}, this.props.listenerClearPayment);

  }

  validateClass(id) {
    let error = this.state.error;
    return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
  }

  validateMessage(id) {
    let error = this.state.error;
    return (error[id] === undefined ? '' : (error[id].message));
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.error !== nextProps.error) {
      this.setState({error: nextProps.error});
    }

    if (nextProps.manual) {
      this.setState({paymentInfo: nextProps.paymentInfo, error: {}});
      this.props.isManual(false);
      this.props.errorListener({});
    }
  }

  getIbanList(callback) {
    let self=this;
    let params = {
      url: `/customer/getCustomerBankByCustomerId`,
      method: "post"
    };
    request(params)
        .then(function (response) {
          this.setState({ibanList: response.data}, callback);
        }.bind(this)).catch(function (error) {
      showAxiosError(error);
      console.log(error);
    });
  }
  selectDefaultIban() {
    let paymentInfo = deepCopyObject(this.state.paymentInfo);
    paymentInfo['paymentFinancialAccountId'] = this.state.ibanList[0].iban;
    this.setState({ paymentInfo }, () => this.props.listener(paymentInfo));
  }
  copyExternalCustomer() {
    let self = this;
    if (self.props.externalCustomer && self.props.externalCustomer.vknTckn && self.props.externalCustomerAddress) {
      let paymentInfo = deepCopyObject(this.state.paymentInfo);
      paymentInfo['paymentFormattedName'] = self.props.externalCustomer.formattedName;
      paymentInfo['paymentVkn'] =  self.props.externalCustomer.vknTckn;
      paymentInfo['paymentCity'] = self.props.externalCustomerAddress.cityName;
      paymentInfo['paymentCountry'] = self.props.externalCustomerAddress.countryName;
      this.setState({paymentInfo});
      self.props.listener(paymentInfo);
    }else{
      Alert.error("Temel Bilgiler kısmından Müşteri Bilgilerini doldurmalısınız veya manüel giriş yapabilirsiniz", {
        position: 'top-right',
        effect: 'stackslide',
        timeout: 5000
      });
    }
  }

  decideIban() {
    const { invoiceTypeCode, isGocIdaresi, isKamu } = this.props;
    const ibanList = deepCopyObject(this.state.ibanList);
    let iban = "";
    if (showChemistInformationModal()) {
      if (invoiceTypeCode === "SGK") {
        const sgkIban = ibanList.find(f => f.type === CustomerBankType.SGK);
        iban = sgkIban ? sgkIban.iban : "";
      } else if (isGocIdaresi || isKamu()) {
        const kamuIban = ibanList.find(f => f.type === CustomerBankType.KAMU);
        iban = kamuIban ? kamuIban.iban : "";
      }
    }
    if (!iban) {
      const otherIban = ibanList.find(f => f.type === CustomerBankType.OTHER || !f.type);
      iban = otherIban ? otherIban.iban : "";
    }

    if (!iban) {
      console.error("Uygun bir IBAN bulunamadı.");
      return;
    }

    this.onChangeSelect({
      target: {
        name: "paymentFinancialAccountId",
        value: iban
      }
    });
  }

  render() {

    if (!this.state.paymentInfo)
      return <div>Yükleniyor...</div>;

    return (
        <div className="row">
          <div className="col-sm-6 row">
            <label className="col-sm-6 col-form-label">Ödeme Şekli* </label>
            <div className="col-sm-6">
              <div className={"form-group" + this.validateClass('paymentMeansCode')}>
                <Select
                    id="paymentMeansCode"
                    clearable={false}
                    value={this.state.paymentInfo.paymentMeansCode}
                    onChange={this.onChangePaymentMeansCode}
                    options={this.props.paymentMeansCodes.map(code => ({ value: code.shortCode, label: code.longCode }))}
                    placeholder="Seçiniz..."
                    noResultsText="Kayıt bulunamadı."
                />
                {this.validateMessage('paymentMeansCode') !== "" &&
                    <UncontrolledTooltip placement="right" target="paymentMeansCode" delay={0}>
                      {this.validateMessage("paymentMeansCode")}
                    </UncontrolledTooltip>}
              </div>
            </div>
          </div>
          <div className="col-sm-6 row">
            <label className="col-sm-6 col-form-label">Ödeme Kanalı </label>
            <div className="col-sm-6">
              <div className={"form-group" + this.validateClass('paymentChannelCode')}>
                <Select
                    id="paymentChannelCode"
                    clearable={false}
                    value={this.state.paymentInfo.paymentChannelCode}
                    onChange={this.onChangePaymentChannelCode}
                    options={this.props.paymentChannelCodes.map(code => ({ value: code.shortCode, label: code.longCode }))}
                    placeholder="Seçiniz..."
                    noResultsText="Kayıt bulunamadı."
                />
                {this.validateMessage('paymentChannelCode') !== "" &&
                    <UncontrolledTooltip placement="right" target="paymentChannelCode" delay={0}>
                      {this.validateMessage("paymentChannelCode")}
                    </UncontrolledTooltip>}
              </div>
            </div>
          </div>
          { this.props.type !== "voucher" && (this.state.ibanList && this.state.ibanList.length > 0) &&
              <div className="col-sm-6 row">
                <div className="col-sm-6 col-form-label">
                  <label className="col-form-label">Kayıtlı IBAN Listesini Göster</label>
                </div>
                <div className="col-sm-6" style={{maxWidth: "none"}}>
                  <div className={"form-group"}>
                    <div className="col-sm-12 row">
                      <input type="checkbox"
                             checked={!this.state.notManualInput}
                             style={{padding: "5px", margin: "5px"}}
                             onChange={this.toggleManualInput}/>
                    </div>
                  </div>
                </div>
              </div>
          }

          {this.props.type !== "voucher" && ((this.state.ibanList && this.state.ibanList.length > 0 &&
              !this.state.notManualInput &&
              (this.state.paymentInfo.paymentFinancialAccountId ?
                  this.state.ibanList &&
                  ibanExistsInPaymentArray(this.state.ibanList, this.state.paymentInfo.paymentFinancialAccountId)
                  :
                  true))
              ?
              <div className="col-sm-6 row">
                <div className="col-sm-6  col-form-label">
                  <label className="col-form-label">IBAN *</label>
                </div>
                <div className="col-sm-6" style={{maxWidth: "none"}}>
                  <div className={"form-group"}>
                    <Select
                        id="paymentFinancialAccountId"
                        clearable={false}
                        value={this.state.paymentInfo.paymentFinancialAccountId ? { value: this.state.paymentInfo.paymentFinancialAccountId, label: this.state.paymentInfo.paymentFinancialAccountId } : null}
                        onChange={this.onChangeIbanSelect}
                        options={this.state.ibanList.map(bank => ({
                          value: bank.iban,
                          label: `${bank.bankName} - ${bank.iban}`,
                        }))}
                        placeholder="Seçiniz..."
                        noResultsText="Kayıt bulunamadı."
                        isClearable={true}
                    />
                  </div>
                </div>
              </div>
              :
              <div className="col-sm-6 row">
                <div className="col-sm-6  col-form-label">
                  <label className="col-form-label">IBAN *</label>
                </div>
                <div className="col-sm-6" style={{maxWidth: "none"}}>
                  <div className={"form-group" + this.validateClass('tPaymentFinancialAccountId')}>
                    <input className="form-control"
                           type="text"
                           id="tPaymentFinancialAccountId"
                           name="paymentFinancialAccountId"
                           data-vlength="1,45"
                           data-vdata="iban"
                           onBlur={this.validateField}
                           ref="tPaymentFinancialAccountId"
                           onChange={this.onChange}
                           value={this.state.paymentInfo.paymentFinancialAccountId || ''}/>
                    {this.validateMessage("tPaymentFinancialAccountId") !== "" &&
                        <UncontrolledTooltip placement="right" target={"tPaymentFinancialAccountId"} delay={0}>
                          {this.validateMessage("tPaymentFinancialAccountId")}
                        </UncontrolledTooltip>}
                  </div>
                </div>
              </div>)
          }

          {this.props.type === "voucher" &&
              <div className="col-sm-6 row">
                <div className="col-sm-6  col-form-label">
                  <label className="col-form-label">Banka Şube Kodu</label>
                </div>
                <div className="col-sm-6" style={{maxWidth: "none"}}>
                  <div className={"form-group" + this.validateClass('payerFinancialInstitution')}>
                    <input className="form-control"
                           type="text"
                           id="payerFinancialInstitution"
                           name="payerFinancialInstitution"
                           data-vlength="1,45"
                           data-vdata="note"
                           ref="payerFinancialInstitution"
                           onChange={this.onChange}
                           value={this.state.paymentInfo.payerFinancialInstitution || ''}/>
                    {this.validateMessage("payerFinancialInstitution") !== "" &&
                        <UncontrolledTooltip placement="right" target={"payerFinancialInstitution"} delay={0}>
                          {this.validateMessage("payerFinancialInstitution")}
                        </UncontrolledTooltip>}
                  </div>
                </div>
              </div>}

          {this.props.type === "voucher" &&
              <div className="col-sm-6 row">
                <div className="col-sm-6  col-form-label">
                  <label className="col-form-label">Müşteri Banka Şube Kodu</label>
                </div>
                <div className="col-sm-6" style={{maxWidth: "none"}}>
                  <div className={"form-group" + this.validateClass('payeeFinancialInstitution')}>
                    <input className="form-control"
                           type="text"
                           id="payeeFinancialInstitution"
                           name="payeeFinancialInstitution"
                           data-vlength="1,45"
                           data-vdata="note"
                           ref="payeeFinancialInstitution"
                           onChange={this.onChange}
                           value={this.state.paymentInfo.payeeFinancialInstitution || ''}/>
                    {this.validateMessage("payeeFinancialInstitution") !== "" &&
                        <UncontrolledTooltip placement="right" target={"payeeFinancialInstitution"} delay={0}>
                          {this.validateMessage("payeeFinancialInstitution")}
                        </UncontrolledTooltip>}
                  </div>
                </div>
              </div>}

          {this.props.type === "voucher" &&
              <div className="col-sm-6 row">
                <div className="col-sm-6  col-form-label">
                  <label className="col-form-label">Yetkili Dosya Numarası</label>
                </div>
                <div className="col-sm-6" style={{maxWidth: "none"}}>
                  <div className={"form-group" + this.validateClass('payerFinancialAccountId')}>
                    <input className="form-control"
                           type="text"
                           id="payerFinancialAccountId"
                           name="payerFinancialAccountId"
                           data-vlength="1,45"
                           data-vdata="note"
                           ref="payerFinancialAccountId"
                           onChange={this.onChange}
                           value={this.state.paymentInfo.payerFinancialAccountId || ''}/>
                    {this.validateMessage("payerFinancialAccountId") !== "" &&
                        <UncontrolledTooltip placement="right" target={"payerFinancialAccountId"} delay={0}>
                          {this.validateMessage("payerFinancialAccountId")}
                        </UncontrolledTooltip>}
                  </div>
                </div>
              </div>}

          {this.props.type === "voucher" &&
              <div className="col-sm-6 row">
                <div className="col-sm-6  col-form-label">
                  <label className="col-form-label">Müşteri Dosya Numarası</label>
                </div>
                <div className="col-sm-6" style={{maxWidth: "none"}}>
                  <div className={"form-group" + this.validateClass('payeeFinancialAccountId')}>
                    <input className="form-control"
                           type="text"
                           id="payeeFinancialAccountId"
                           name="payeeFinancialAccountId"
                           data-vlength="1,45"
                           data-vdata="note"
                           ref="payeeFinancialAccountId"
                           onChange={this.onChange}
                           value={this.state.paymentInfo.payeeFinancialAccountId || ''}/>
                    {this.validateMessage("payeeFinancialAccountId") !== "" &&
                        <UncontrolledTooltip placement="right" target={"payeeFinancialAccountId"} delay={0}>
                          {this.validateMessage("payeeFinancialAccountId")}
                        </UncontrolledTooltip>}
                  </div>
                </div>
              </div>}

          {this.props.type === "voucher" &&
              <div className="col-sm-6 row">
                <div className="col-sm-6  col-form-label">
                  <label className="col-form-label">Ödemenin Bitiş Tarihi</label>
                </div>
                <div className="col-sm-6" style={{maxWidth: "none"}}>
                  <div className={"form-group" + this.validateClass('paymentDueDate')}>
                    <Datetime locale="tr"
                              className="datepicker"
                              input={true}
                              inputProps={{id:"paymentDueDate"}}
                              onBlur={(momentObj)=>this.validateField({target:{id:"paymentDueDate",dataset:{'vdata':"date",'vlength':(this.state.paymentInfo.referenceId ? "1,255":"0,255")},value:(!(typeof momentObj === "string") ? momentObj.format("DD-MM-YYYY") : momentObj)}})}
                              closeOnSelect={true}
                              value={moment(this.state.paymentInfo.paymentDueDate,"YYYY-MM-DD",true).isValid() ? moment(this.state.paymentInfo.paymentDueDate).format("DD-MM-YYYY"):this.state.paymentInfo.paymentDueDate}
                              dateFormat="DD-MM-YYYY"
                              timeFormat={false}
                              onChange={(momentObj) => this.onChange({target:{name:'paymentDueDate',dataset:{'vdata':"date",'vlength':"1,50"}, value:(!(typeof momentObj === "string") ? momentObj.format("YYYY-MM-DD") : momentObj)}})}/>
                    {this.validateMessage("paymentDueDate") !== "" &&
                        <UncontrolledTooltip placement="right" target={"paymentDueDate"} delay={0}>
                          {this.validateMessage("paymentDueDate")}
                        </UncontrolledTooltip>}
                  </div>
                </div>
              </div>}

          <div className="col-sm-6 row">
            <div className="col-sm-6  col-form-label">
              <label className="col-form-label">Açıklama</label>
            </div>
            <div className="col-sm-6" style={{maxWidth: "none"}}>
              <div className={"form-group" + this.validateClass('instructionNote')}>
                <input className="form-control"
                       type="text"
                       id="instructionNote"
                       name="instructionNote"
                       data-vlength="1,45"
                       data-vdata="note"
                       ref="instructionNote"
                       onChange={this.onChange}
                       value={this.state.paymentInfo.instructionNote || ''}/>
                {this.validateMessage("instructionNote") !== "" &&
                    <UncontrolledTooltip placement="right" target={"instructionNote"} delay={0}>
                      {this.validateMessage("instructionNote")}
                    </UncontrolledTooltip>}
              </div>
            </div>
          </div>
          {this.props.isKamu() &&
              <React.Fragment>
                <div className="col-sm-12 row">
                  <label className="col-sm-6 col-form-label" style={{paddingTop:'4px',fontSize:"14px",fontWeight:"bold"}}>Ödeme yapacak firma /kurum bilgileri
                    <CopyToClipboard text={""} onCopy={() => this.copyExternalCustomer()}>
                      <button className="btn "
                              style={{
                                padding: "0px 9px 0px 9px",
                                margin: "0px",
                                backgroundColor: "inherit",
                                color: "#78b1d7"
                              }}>
                        <i className="far fa-copy"></i>
                      </button>
                    </CopyToClipboard>
                  </label>
                </div>
                <div className="col-sm-6 row">
                  <label className="col-sm-6 col-form-label">Unvan* </label>
                  <div className="col-sm-6">
                    <div className={"form-group" + this.validateClass('paymentFormattedName')}>
                      <input className="form-control"
                             type="text"
                             id="paymentFormattedName"
                             name="paymentFormattedName"
                             data-vlength="0,350"
                             onBlur={this.validateField}
                             ref="paymentFormattedName"
                             onChange={this.onChange}
                             value={this.state.paymentInfo.paymentFormattedName || ''}/>
                      {this.validateMessage('paymentFormattedName') !== "" &&
                          <UncontrolledTooltip placement="right" target="paymentFormattedName" delay={0}>
                            {this.validateMessage("paymentFormattedName")}
                          </UncontrolledTooltip>}
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 row">
                  <label className="col-sm-6 col-form-label">VKN* </label>
                  <div className="col-sm-6">
                    <div className={"form-group" + this.validateClass('paymentVkn')}>
                      <input className="form-control"
                             type="text"
                             id="paymentVkn"
                             name="paymentVkn"
                             data-vlength="0,10"
                             onBlur={this.validateField}
                             ref="paymentVkn"
                             onChange={this.onChange}
                             value={this.state.paymentInfo.paymentVkn || ''}/>
                      {this.validateMessage('paymentVkn') !== "" &&
                          <UncontrolledTooltip placement="right" target="paymentVkn" delay={0}>
                            {this.validateMessage("paymentVkn")}
                          </UncontrolledTooltip>}
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 row">
                  <label className="col-sm-6 col-form-label">İl* </label>
                  <div className="col-sm-6">
                    <div className={"form-group" + this.validateClass('paymentCity')}>
                      <input className="form-control"
                             type="text"
                             id="paymentCity"
                             name="paymentCity"
                             data-vlength="0,255"
                             onBlur={this.validateField}
                             ref="paymentCity"
                             onChange={this.onChange}
                             value={this.state.paymentInfo.paymentCity || ''}/>
                      {this.validateMessage('paymentCity') !== "" &&
                          <UncontrolledTooltip placement="right" target="paymentCity" delay={0}>
                            {this.validateMessage("paymentCity")}
                          </UncontrolledTooltip>}
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 row">
                  <label className="col-sm-6 col-form-label">Ülke* </label>
                  <div className="col-sm-6">
                    <div className={"form-group" + this.validateClass('paymentCountry')}>
                      <input className="form-control"
                             type="text"
                             id="paymentCountry"
                             name="paymentCountry"
                             data-vlength="0,255"
                             onBlur={this.validateField}
                             ref="paymentCountry"
                             onChange={this.onChange}
                             value={this.state.paymentInfo.paymentCountry || ''}/>
                      {this.validateMessage('paymentCountry') !== "" &&
                          <UncontrolledTooltip placement="right" target="paymentCountry" delay={0}>
                            {this.validateMessage("paymentCountry")}
                          </UncontrolledTooltip>}
                    </div>
                  </div>
                </div>
              </React.Fragment>
          }
          {this.props.type !== "voucher" &&
              <div className="col-sm-6 row">
                <div className="col-sm-12">
                  <button type="button"
                          className="TekBtn delete"
                          onClick={this.clearPayment}
                          style={{background: '#FFCCCC'}}
                  >Tümünü Temİzle
                  </button>
                </div>
              </div>}
        </div>
    );
  }
}

export default Payment;